import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {MatButton} from "@angular/material/button";
import {TranslatePipe} from "@ngx-translate/core";
import {ErrorService} from "../../../services/error/error.service";

@Component({
    selector: "app-error-message-panel",
    imports: [
        MatButton,
        TranslatePipe,
    ],
    templateUrl: "./error-message-panel.component.html",
    styleUrl: "./error-message-panel.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessagePanelComponent {
    protected readonly errorService = inject(ErrorService);
}
